/** Utility class that creates an internal object for reverse mapping */
export class TwoWayMap {
	constructor(forwardMap, defaultKey, defaultValue) {
		this.resetAll(forwardMap)
		this.defaultValue = defaultValue
		this.defaultKey = defaultKey
	}

	resetAll(forwardMap) {
		this.forwardMap = { ...forwardMap }
		this.backwardMap = Object.entries(forwardMap).reduce((bwdMap, [key, value]) => {
			bwdMap[value] = key
			return bwdMap
		}, {})
	}

	forward(key) {
		return this.forwardMap[key] ?? this.defaultValue
	}

	backward(value) {
		return this.backwardMap[value] ?? this.defaultKey
	}

	get length() {
		return Object.keys(this.forwardMap).length
	}

	get keys() {
		return Object.keys(this.forwardMap)
	}

	get values() {
		return Object.values(this.forwardMap)
	}

	set(key, value) {
		this.forwardMap[key] = value
		this.backwardMap[value] = key
	}

	deleteByKey(key) {
		const value = this.forwardMap[key]
		delete this.forwardMap[key]
		delete this.backwardMap[value]
	}

	deleteByValue(value) {
		const key = this.backwardMap[value]
		delete this.forwardMap[key]
		delete this.backwardMap[value]
	}
}
